import { Size } from '@/hooks/useScreenSize';

const scrollTextClassMap: Record<Size, string> = {
  sm: 'text-font-size-bold-font-size-12 leading-line-height-xs text-color-content-text-primary',
  md: 'text-font-size-bold-font-size-12 leading-line-height-xs text-color-content-text-primary',
  lg: 'text-font-size-bold-font-size-12 leading-line-height-xs text-color-content-text-primary',
  xl: 'text-font-size-bold-font-size-12 leading-line-height-xs text-color-content-text-primary',
  xxl: 'text-font-size-bold-font-size-12 leading-line-height-xs text-color-content-text-primary',
};

export { scrollTextClassMap };
